import {
  getStoredMarketingConsent,
  setStoredMarketingConsent,
} from '@app/utils/marketingConsent';
import type { UserInfo } from '@redbubble/next/types';
import { useUserInfo } from '@redbubble/next-provider';
import { useCallback, useEffect, useState } from 'react';

export const useMarketingConsent = (): [
  boolean,
  (consent: boolean) => void,
] => {
  const [{ cloudflare }] = useUserInfo<UserInfo>();

  const [consent, setConsent] = useState(cloudflare?.ipCountry === 'US');

  useEffect(() => {
    const storedConsent = getStoredMarketingConsent();
    if (storedConsent !== undefined) {
      setConsent(storedConsent);
    }
  }, []);

  const updateConsent = useCallback((value: boolean) => {
    setStoredMarketingConsent(value);
    setConsent(value);
  }, []);

  return [consent, updateConsent];
};
